var render, staticRenderFns
import script from "./AppBindezPagination.vue?vue&type=script&lang=js&"
export * from "./AppBindezPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2754f324",
  null
  
)

export default component.exports